import { render, staticRenderFns } from "./typingIndicator.vue?vue&type=template&id=8ba2b0de&"
var script = {}
import style0 from "./typingIndicator.vue?vue&type=style&index=0&id=8ba2b0de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports